import gql from 'graphql-tag';

export const getVectaryModelListing = gql`query{
    getVectaryModelListing {
        edges {
            node {
              id
                modelId
            }
        }
    }
}`;
